import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M3.98993 44.3718C3.98993 44.3718 6.48995 38.8718 7.06995 33.1418C7.64995 27.4218 8.41993 15.9718 11.2999 13.9818C11.2999 13.9818 19.7499 13.6518 27.4499 12.6618C36.5999 11.4818 43.7899 13.7618 43.7899 13.7618L46.1899 8.5918C46.1899 8.5918 45.57 5.5318 44.17 4.7118C42.77 3.8918 37.0599 0.331803 23.5999 1.2118C10.1399 2.0918 4.94995 11.1218 3.41995 13.9818C1.87995 16.8518 0.339928 39.0918 3.98993 44.3718Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M46.1899 8.5918C50.3699 9.7518 51.0199 12.3118 51.8199 13.9818C53.2299 16.9318 54.8999 39.0818 51.2399 44.3718C51.2399 44.3718 48.7399 38.8718 48.1599 33.1418C47.5799 27.4118 46.8099 15.9718 43.9299 13.9818L46.1899 8.5918Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M15.28 13.3018C15.28 13.3018 20.25 7.6018 29.48 8.0418C38.71 8.4818 41.78 11.7818 45.05 10.0218"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M12.1899 13.5417C12.1899 13.5417 17.9699 6.38172 26.4099 5.83172C36.5999 5.17172 39.0499 9.57172 46.1899 8.58172"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M44.4799 5.62178C41.3999 6.94178 32.9499 2.76178 23.1399 3.42178C13.3299 4.08178 8.54989 12.0618 6.69989 15.7818C4.84989 19.5018 2.36987 22.5518 2.36987 22.5518"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M45.0601 12.4419C45.0601 12.4419 47.7501 13.5419 49.2901 19.2719C50.8301 24.9919 50.8301 31.1619 52.7501 32.7019"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M45.4399 10.9019C45.4399 10.9019 49.0899 12.0019 50.2499 17.2919C51.3999 22.5719 52.3599 26.3219 53.1299 26.3219"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M47.75 23.2317C47.75 23.2317 49.1 35.7817 53.13 36.6617"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.72992 17.7317C8.72992 17.7317 5.24992 25.4917 2.16992 27.2517"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.95993 22.7917C7.95993 22.7917 5.26994 30.0617 2.18994 30.9417"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.76001 30.7219C7.76001 30.7219 5.62001 36.8319 2.76001 38.8719"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
